import React from "react";

// Recognises inline [PRIMARY INSIGHT], [HIGH IMPACT], [RELATIONSHIP LEVERAGE], [PROOF POINT] tags
// and renders them as coloured pills while preserving surrounding text.

const TAG_STYLES = {
  "PRIMARY INSIGHT": "bg-[#0A84FF]/15 text-[#0A84FF] border-[#0A84FF]/40",
  "HIGH IMPACT": "bg-[#FF9F0A]/15 text-[#FF9F0A] border-[#FF9F0A]/40",
  "RELATIONSHIP LEVERAGE": "bg-[#5E5CE6]/20 text-[#a9a7f8] border-[#5E5CE6]/40",
  "PROOF POINT": "bg-[#32D74B]/15 text-[#32D74B] border-[#32D74B]/40",
};

const TAG_REGEX = /\[(PRIMARY INSIGHT|HIGH IMPACT|RELATIONSHIP LEVERAGE|PROOF POINT)\]/g;

export const TaggedText = ({ text, className = "" }) => {
  if (!text) return <span className="text-[#525252]">—</span>;
  const parts = [];
  let lastIndex = 0;
  let m;
  let key = 0;
  TAG_REGEX.lastIndex = 0;
  while ((m = TAG_REGEX.exec(text)) !== null) {
    if (m.index > lastIndex) {
      parts.push(<span key={key++}>{text.slice(lastIndex, m.index)}</span>);
    }
    const tag = m[1];
    const style = TAG_STYLES[tag] || "bg-[#262626] text-white border-[#404040]";
    parts.push(
      <span
        key={key++}
        className={`inline-flex items-center px-1.5 py-0.5 rounded-sm border text-[10px] font-mono-data tracking-wider uppercase mx-0.5 align-baseline ${style}`}
      >
        {tag}
      </span>
    );
    lastIndex = m.index + m[0].length;
  }
  if (lastIndex < text.length) {
    parts.push(<span key={key++}>{text.slice(lastIndex)}</span>);
  }
  return <span className={className}>{parts}</span>;
};

export const TagPills = ({ tags = [] }) => {
  if (!tags || tags.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1">
      {tags.map((t, i) => {
        const label = t.replace(/_/g, " ").toUpperCase();
        const style = TAG_STYLES[label] || "bg-[#262626] text-white border-[#404040]";
        return (
          <span
            key={i}
            className={`inline-flex items-center px-1.5 py-0.5 rounded-sm border text-[10px] font-mono-data tracking-wider uppercase ${style}`}
          >
            {label}
          </span>
        );
      })}
    </div>
  );
};

export default TaggedText;
